<template>
    <div style="overflow: hidden">
        <el-container style="background: #fff;">
            <el-aside width="165px" style="margin:5px 5px 5px 5px;">
                <div style="width: 155px;margin-left: 3px;">
                    <el-form ref="balForm" label-position="top" :model="balForm"  :show-message=false>
                        <el-row :gutter=8>
                            <el-col :span=24>
                                <el-form-item label="账单号码" prop="invocieNo">
                                    <el-input v-model="balForm.invocieNo" :readonly="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter=8>
                            <el-col :span=24>
                                <el-form-item label="账单日期" prop="invoiceTime">
                                    <zm-date v-model="balForm.invoiceTime" :date-type="'date'" :format="'yyyy-MM-dd'" :disabled="true"></zm-date>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter=8>
                            <el-col :span=24>
                                <el-form-item label="网点" prop="station">
                                    <el-input v-model="balForm.station" :readonly="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter=8>
                            <el-col :span=24>
                                <el-form-item label="客户" prop="custName">
                                    <el-input v-model="balForm.custName" :readonly="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-aside>
            <el-main>
                <el-container>
                    <el-header style="padding: 5px 0;height:130px !important;">
                        <div class="dialog-content" style="padding: 0 4px 0 0 !important;">
                            <div class="dialog-main">
                                <el-row :gutter=8>
                                    <el-col :span=5>
                                        <zm-no ref="nos" table-name="bas_no_type" :rows=4 :default-type="'1'"
                                               :max-row=300 :filter-data="filterNoType"></zm-no>
                                    </el-col>
                                    <el-col :span=19>
                                        <el-row :gutter=8 style="margin-top: 60px;" v-if="!progressShow">
                                            <el-col :span=24>
                                                <span style="color: red;font-size: 12px;">注意:客户未确认的费用，需备注异常:无异常费用可通过非异常确认“一次性确认</span>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter=8 style="margin-top: 30px;" v-else>
                                          <div style="display: inline-block" v-show="progressShow">
                                            <el-progress :text-inside="true" :stroke-width="30"
                                                         :percentage="percentage" style="width:600px;padding-left: -40px;"></el-progress>
                                          </div>
                                          <el-col :span=24>
                                            <span style="color: red;font-size: 12px;">注意:客户未确认的费用，需备注异常:无异常费用可通过非异常确认“一次性确认</span>
                                          </el-col>
                                        </el-row>
                                        <el-row :gutter=8 style="margin-top: 10px;">
                                            <el-col :span=24>
                                                <el-button type="primary" @click="$refs['subtable'].query()" :loading="queryLoading" class="zm-button2">查询</el-button>

                                                <el-button type="danger" @click="getparamstr" class="zm-butto3">异常备注</el-button>

                                                <zm-button text="非异常确认" bt-class="zm-button4" type="primary" :before-click="exceptParams"
                                                           :get-params="exceptSubmit" @success="exceptSubSuc"></zm-button>

                                                <zm-button text="选择确认" bt-class="zm-button3" type="primary" :before-click="choiceParams"
                                                           :get-params="choiceSubmit" @success="choiceSubSuc" ></zm-button>

                                                <zm-button text="全部确认" bt-class="zm-button3" type="primary" :before-click="allParams"
                                                           :get-params="allSubmit" @success="allSubSuc" ></zm-button>

                                                <zm-button text="选择取消" bt-class="zm-button3" type="danger" :before-click="cancelParams"
                                                           :get-params="cancelSubmit" @success="cancelSubSuc" ></zm-button>

                                                <zm-button text="全部取消" bt-class="zm-button3" type="danger" :before-click="cancelQBParams"
                                                           :get-params="cancelQBSubmit" @success="cancelQBSubSuc" ></zm-button>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-header>
                    <el-main>
                        <common-table ref="subtable" :table-height="370" :col="col"  :pagination=true table-no="BMS06002-001"
                                      :single-select="false" :startQuery="false" :show-footer="true"
                                      @selection-change="selectChangeFun" :is-auto="false"
                                      :get-params="getTableParam" @button-loading="val => queryLoading = val">
                        </common-table>
                    </el-main>
                </el-container>
            </el-main>
        </el-container>
        <!--异常备注-->
        <el-dialog v-dialogDrag
                   title="设置异常备注"
                   :visible.sync="editVisible" :append-to-body="true"
                   width="420px"
                   :close-on-click-modal="false">
            <div class="dialog-content" style="height: 380px;">
                <div class="dialog-main">
                    <el-form ref="collectHxForm" label-position="top" :model="collectHxForm"
                             :show-message=false>
                        <div class="section" style="margin-top: 10px;">
                            <div class="title">
                                <span class="title-text">设置异常备注</span>
                            </div>
                            <div class="body">
                                <el-row :gutter="8">
                                    <el-col :span="24">
                                        <el-form-item label="异常备注" prop="remark3">
                                            <el-input type="textarea" :rows="14" v-model="collectHxForm.remark3"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="8">
                                    <el-col :span="24" >
                                        <el-button type=info @click="editVisible = false" class="zm-button2" style="float:right;margin-left: 8px;">取消</el-button>
                                        <el-button class="zm-button2" type="primary" @click="click3" style="float:right">保存</el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: "BMS06002",
        props: {
            excelTemplateId:{
                type:Number,
                required: true
            }
        },
        data() {
            return {
                collectHxForm:{
                    remark3:'',
                },
                editVisible:false,
                progressShow:false,
                percentage:0,
                queryLoading:false,
                showFooter:true,
                param1:'',
                maintable:[],
                subtable:[],
                selectData:[],
                balForm:{},
                col: [
                    {value: 'ackStatus', text: '确认', width: 60, filter: 'zmtrue'},
                    {value: 'remark3', text: '异常说明', width: 150},
                    {value: 'invocieNo', text: '账单号码',width: 130},
                    {value: 'jobno', text: '运单号码',width: 80},
                    {value: 'sdStation', text: '网点名称',width: 100},
                    {value: 'sdDate', text: '寄件日期', width: 100, filter: 'zmdate'},
                    {value: 'sdCustCode', text: '客户编码',width: 80},
                    {value: 'sdCustName', text: '客户名称',width: 100},
                    {value: 'ardedName', text: '科目名称',width: 100},
                    {value: 'charge', text: '金额',width: 80,align: 'right', formatter: this.zmDefaultDecima2},
                    {value: 'chargeCur', text: '币别',width: 60},
                    {value: 'formula', text: '计算公式',width: 120},
                    {value: 'packTypeName', text: '包装类型',width: 80},
                    {value: 'hubinName', text: '指定路线',width: 80},
                    {value: 'destName', text: '目的地',width: 100},
                    {value: 'weig', text: '收费重',width: 100,align: 'right', formatter: this.zmDefaultDecima3},
                    {value: 'invoiceDate', text: '账单日期', width: 100, filter: 'zmdate'},
                    {value: 'remark', text: '备注',width: 120}
                ]

            }
        },
        created(){
        },
        activated() {
        },
        methods:{
          shenheSucFun(num,msg) {
            if (this.timerProgress) {
              this.percentage = 0;
              window.clearInterval(this.timerProgress);
            }
            //5秒钟查询一次
            this.timerProgress = setInterval(() => {
              this.$httpService.get('bms/invoicedetail/query/progress',{taskId:num}).then(res => {
                if(res){
                  this.percentage=res.precent;
                  if(res.precent==100){
                    if(res.errorDesc){
                      this.progressShow=false;
                      //执行完成，返回
                      window.clearInterval(this.timerProgress);
                      this.$nextTick(() => {
                        this.$util.show(res.errorDesc,2);
                        this.$refs['subtable'].query();
                      });
                    }else{
                      this.progressShow=false;
                      //执行完成，返回
                      window.clearInterval(this.timerProgress);
                      this.$nextTick(() => {
                        this.$util.show(msg);
                        this.$refs['subtable'].query();
                      });
                    }
                  }
                }
              }).catch(() => {
                //查询失败就关闭定时器
                window.clearInterval(this.timerProgress);
              });
            }, 5000);
          },

            //取消确认
            getparamstr() {
                this.selectData = this.$refs['subtable'].getSeleteRow();
                console.log(this.selectData)
                var count = this.selectData.length;
                if (count == 0) {
                    this.$util.show("请选择需要设置异常备注的数据", 1);
                    return ;
                } else if(count==1){
                    this.editVisible=true;
                    var invocieIdList=[];
                    if(this.balForm.status!=1){
                        invocieIdList.push(this.balForm.id);
                        let params = {
                            invocieIdList:invocieIdList,
                        };
                        this.collectHxForm.remark3="";
                        this.$httpService.post('bms/invoice/audit', params).then(res => {
                            this.$nextTick(() => {
                                this.findInvoice(this.balForm.id);
                            });
                            this.collectHxForm.remark3=this.selectData[0].remark3;
                        }).catch(rs=>{
                            this.$util.show('当前账单自动审核失败！',1);
                            return ;
                        })
                    }else{
                        this.editVisible=true;
                        this.collectHxForm.remark3=this.selectData[0].remark3;
                    }
                }else{
                    this.$util.show("请选择一条需要设置异常备注的数据", 1);
                    return ;
                }
            },
            click3(){
                var _params2 = {
                    remark3:this.collectHxForm.remark3,
                    id:this.selectData[0].id,
                };
                this.$httpService.post('bms/receiptcust/remark/modify', _params2).then(res => {
                    console.log(res);
                    if(res){
                      this.progressShow=true;
                      this.percentage = 0;
                      this.editVisible=false;
                      this.shenheSucFun(res,"异常备注设置成功");
                    }
                });
            },
            //非异常选中锁定
            exceptParams() {
                return new Promise((resolve, reject) => {
                    var invocieIdList=[];
                    if(this.balForm.status!=1){
                        invocieIdList.push(this.balForm.id);
                        let params = {
                            invocieIdList:invocieIdList,
                        };
                        this.$httpService.post('bms/invoice/audit', params).then(res => {
                            this.$nextTick(() => {
                                this.findInvoice(this.balForm.id);
                            });
                            this.$confirm('此操作将确认所有非异常的数据, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                resolve();
                            }).catch(() => {
                                reject();
                            });
                        }).catch(rs=>{
                            this.$util.show('当前账单自动审核失败！',1);
                            reject();
                        })
                    }else{
                        this.$confirm('此操作将确认所有非异常的数据, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            resolve();
                        }).catch(() => {
                            reject();
                        });
                    }
                })
            },
            exceptSubmit() {
                var _params = {
                    invoiceId: this.param2,
                    remark3:"异常备注"
                };
                return {
                    url: 'bms/receiptcust/except/modify',
                    params: _params
                }

            },
            exceptSubSuc(row) {
                console.log(row);
                if(row){
                  this.progressShow=true;
                  this.percentage = 0;
                  this.shenheSucFun(row,"确认数据成功");
                }
            },

            //选中锁定
            choiceParams() {
                return new Promise((resolve, reject) => {
                    this.selectData = this.$refs['subtable'].getSeleteRow();
                    var count = this.selectData.length;
                    if (count == 0) {
                        this.$util.show("请选择需要确认的数据", 1);
                        reject();
                    } else {
                        var invocieIdList=[];
                        if(this.balForm.status!=1){
                            invocieIdList.push(this.balForm.id);
                            let params = {
                                invocieIdList:invocieIdList,
                            };
                            this.$httpService.post('bms/invoice/audit', params).then(res => {
                                this.$nextTick(() => {
                                    this.findInvoice(this.balForm.id);
                                });
                                this.$confirm('此操作将确认选中的数据, 是否继续?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    resolve();
                                }).catch(() => {
                                    reject();
                                });
                            }).catch(rs=>{
                                this.$util.show('当前账单自动审核失败！',1);
                                reject();
                            })
                        }else{
                            this.$confirm('此操作将确认选中的数据, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                resolve();
                            }).catch(() => {
                                reject();
                            });
                        }
                    }
                })
            },
            choiceSubmit() {
                var idsList = [];
                for(var i=0;i<this.selectData.length;i++){
                    idsList.push(this.selectData[i].id);
                }
                var _params = {
                    invoiceId: this.param2,
                    listIds:JSON.stringify(idsList)
                };
                return {
                    url: 'bms/receiptcust/choice/confirm',
                    params: _params
                }

            },
            choiceSubSuc(row) {
              console.log(row);
              if(row){
                this.progressShow=true;
                this.percentage = 0;
                this.shenheSucFun(row,"确认数据成功");
              }
            },

            //取消确认
            cancelParams() {
                return new Promise((resolve, reject) => {
                    this.selectData = this.$refs['subtable'].getSeleteRow();
                    var count = this.selectData.length;
                    if (count == 0) {
                        this.$util.show("请选择需要取消确认的数据", 1);
                        reject();
                    } else {
                        var invocieIdList=[];
                        if(this.balForm.status!=1){
                            invocieIdList.push(this.balForm.id);
                            let params = {
                                invocieIdList:invocieIdList,
                            };
                            this.$httpService.post('bms/invoice/audit', params).then(res => {
                                this.$nextTick(() => {
                                    this.findInvoice(this.balForm.id);
                                });
                                this.$confirm('此操作将取消选中的数据, 是否继续?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    resolve();
                                }).catch(() => {
                                    reject();
                                });
                            }).catch(rs=>{
                                this.$util.show('当前账单自动审核失败！',1);
                                reject();
                            })
                        }else{
                            this.$confirm('此操作将取消选中的数据, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                resolve();
                            }).catch(() => {
                                reject();
                            });
                        }
                    }
                })
            },
            cancelSubmit() {
                var idsList = [];
                for(var i=0;i<this.selectData.length;i++){
                    idsList.push(this.selectData[i].id);
                }
                var _params = {
                    invoiceId: this.param2,
                    listIds:JSON.stringify(idsList)
                };
                return {
                    url: 'bms/receiptcust/cancel/confirm',
                    params: _params
                }

            },
            cancelSubSuc(row) {
              console.log(row);
              if(row){
                this.progressShow=true;
                this.percentage = 0;
                this.shenheSucFun(row,"取消确认成功");
              }
            },
            cancelQBParams() {
              //全部取消确认
              return new Promise((resolve, reject) => {
                if(this.balForm.status!=1){
                  let params = {
                    invocieIdList:[this.balForm.id],
                  };
                  this.$httpService.post('bms/invoice/audit', params).then(res => {
                    this.$nextTick(() => {
                      this.findInvoice(this.balForm.id);
                    });
                    this.$confirm('此操作将取消全部数据, 是否继续?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                      resolve();
                    }).catch(() => {
                      reject();
                    });
                  }).catch(rs=>{
                    this.$util.show('当前账单自动审核失败！',1);
                    reject();
                  })
                }else{
                  this.$confirm('此操作将取消全部数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    resolve();
                  }).catch(() => {
                    reject();
                  });
                }
              })
            },
            cancelQBSubmit() {
              var _params = {
                invoiceId: this.param2,
              };
              return {
                url: 'bms/receiptcust/cancel/all/confirm',
                params: _params
              }

            },
            cancelQBSubSuc(row) {
              console.log(row);
              if(row){
                 this.progressShow=true;
                 this.percentage = 0;
                 this.shenheSucFun(row,"全部取消确认成功");
              }
            },
            //单号类型，只有运单号码
            filterNoType(param) {
                let array = [];
                let params = ['1'];
                if (param) {
                    for (let i = 0; i < param.length; i++) {
                        if (params.indexOf(param[i].value) > -1) {
                            array.push(param[i]);
                        }
                    }
                }
                return array;
            },
            //根据账单id查询账单信息
            findInvoice(invoiceId){
                this.$httpService.get('/bms/receiptcust/invoice/find', {invoiceId: invoiceId}).then(res => {
                    if (res) {
                        this.balForm = res;
                        console.log(res);
                        console.log(invoiceId);
                        this.balForm.invoiceTime = this.$options.filters['zmdate'](res.invoiceTime)+"";
                    }
                }).catch(res => {
                    this.$util.show('账单信息查询异常', 1);
                });
                this.$refs['subtable'].query();
            },
            selectChangeFun(val){
                console.log(123);
            },
            // 保留2位小数
            zmDefaultDecima2:function(value) {
                if(value){
                    return value.toFixed(2);
                }
                return '0.00';
            },
            // 保留3位小数
            zmDefaultDecima3:function (value) {
                if(value){
                    return value.toFixed(3);
                }
                return '0.00';
            },
            getTableParam(){
                this.param2=this.excelTemplateId;
                var _params = {
                    invoiceId: this.param2,
                    jobnos:this.$refs['nos'].getValue().no
                };
                return {
                    url:'bms/receiptcust/invoicedetail/list',
                    params:_params
                }
            },
            //排除确认
            notParams() {
                return new Promise((resolve, reject) => {
                    this.selectData = this.$refs['subtable'].getSeleteRow();
                    var count = this.selectData.length;
                    if (count == 0) {
                        this.$util.show("请选择需要排除确认的数据", 1);
                        reject();
                    } else {
                        var invocieIdList=[];
                        if(this.balForm.status!=1){
                            invocieIdList.push(this.balForm.id);
                            let params = {
                                invocieIdList:invocieIdList,
                            };
                            this.$httpService.post('bms/invoice/audit', params).then(res => {
                                this.$nextTick(() => {
                                    this.findInvoice(this.balForm.id);
                                });
                                this.$confirm('此操作将确认该账单非选择所有数据, 是否继续?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    resolve();
                                }).catch(() => {
                                    reject();
                                });
                            }).catch(rs=>{
                                this.$util.show('当前账单自动审核失败！',1);
                                reject();
                            })
                        }else{
                            this.$confirm('此操作将确认该账单非选择所有数据, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                resolve();
                            }).catch(() => {
                                reject();
                            });
                        }
                    }
                })
            },
            notSubmit() {
                var idsList = [];
                for(var i=0;i<this.selectData.length;i++){
                    idsList.push(this.selectData[i].id);
                }
                var _params = {
                    invoiceId: this.param2,
                    listIds:JSON.stringify(idsList)
                };
                return {
                    url: 'bms/receiptcust/not/confirm',
                    params: _params
                }

            },
            notSubSuc(row) {
                console.log(row);
                this.$util.show('排除确认成功');
                this.$refs['subtable'].query();
            },
            //全部确认
            allParams() {
                return new Promise((resolve, reject) => {
                    var invocieIdList=[];
                    if(this.balForm.status!=1){
                        invocieIdList.push(this.balForm.id);
                        let params = {
                            invocieIdList:invocieIdList,
                        };
                        this.$httpService.post('bms/invoice/audit', params).then(res => {
                            this.$nextTick(() => {
                                this.findInvoice(this.balForm.id);
                            });
                            this.$confirm('此操作将确认该账单所有数据, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                resolve();
                            }).catch(() => {
                                reject();
                            });
                        }).catch(rs=>{
                            this.$util.show('当前账单自动审核失败！',1);
                            reject();
                        })
                    }else{
                        this.$confirm('此操作将确认该账单所有数据, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            resolve();
                        }).catch(() => {
                            reject();
                        });
                    }
                })
            },
            sumint(){
                var invocieIdList=[];
                if(this.balForm.status!=1){
                    invocieIdList.push(this.balForm.id);
                    let params = {
                        invocieIdList:invocieIdList,
                    };
                    this.$httpService.post('bms/invoice/audit', params).then(res => {
                        this.$nextTick(() => {
                            this.findInvoice(this.balForm.id);
                        });
                    })
                }
            },
            allSubmit() {
                var _params = {
                    invoiceId: this.param2
                };
                return {
                    url: 'bms/receiptcust/all/confirm',
                    params: _params
                }

            },
            allSubSuc(row) {
              console.log(row);
              if(row){
                this.progressShow=true;
                this.percentage = 0;
                this.shenheSucFun(row,"全部确认成功");
              }
            }
        }
    }
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// ../../src/pages/bms/cashier/custcollect_confirm.vue